import React, { createContext, useState, ReactNode } from 'react';

interface OptionsModalContextProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const OptionsModalContext = createContext<OptionsModalContextProps>({
	isOpen: false,
	setIsOpen: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function OptionsModalProvider({ children }: ContextProps) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<OptionsModalContext.Provider value={{ isOpen, setIsOpen }}>
			{children}
		</OptionsModalContext.Provider>
	);
}

export default OptionsModalContext;
